import type { SocialTrackingMetadataInput } from '@xing-com/crate-common-graphql-types';

export const getSocialTrackingMetaData = ({
  backendTrackingMetaData,
  propSocialInteractionId,
  referrerUrl,
}: {
  backendTrackingMetaData?: SocialTrackingMetadataInput;
  propSocialInteractionId?: string;
  referrerUrl?: string;
}): { trackingMetadata: SocialTrackingMetadataInput } => ({
  trackingMetadata: {
    channel: 'web',
    deliveryTimestamp: new Date(Date.now()).toISOString(),
    referrerUrl: referrerUrl || global?.top?.location?.href || '',
    trackingUUID: propSocialInteractionId,
    userAgent: global?.navigator?.userAgent || '',
    ...backendTrackingMetaData,
  },
});
